import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import {
  CheckboxCheckedIcon,
  CheckboxIcon,
  FieldWrapper,
  FormOption
} from 'common/form';
import { teamCheckboxGroupSx } from 'modules/candidate-profile/styles/teamCheckboxGroupSx';

type TeamCheckboxGroupProps = {
  name?: string;
  label?: string;
  options: FormOption[];
  value: string[];
  errorMessage?: string;
  onChange: (value: string[]) => void;
};

const toggle = (values: string[], value: string) =>
  values.includes(value)
    ? values.filter((v) => v !== value)
    : [...values, value];

export const TeamCheckboxGroup: React.FC<TeamCheckboxGroupProps> = ({
  name,
  label,
  options,
  value,
  errorMessage,
  onChange
}) => (
  <FieldWrapper label={label} errorMessage={errorMessage}>
    <Stack data-testid={`checkbox-group-${name}`} gap="15px" mt="10px">
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          sx={teamCheckboxGroupSx.label}
          label={option.label}
          control={
            <Checkbox
              checked={value.includes(option.value)}
              onChange={() => onChange(toggle(value, option.value))}
              icon={<CheckboxIcon />}
              checkedIcon={<CheckboxCheckedIcon />}
              sx={teamCheckboxGroupSx.checkbox}
            />
          }
        />
      ))}
    </Stack>
  </FieldWrapper>
);
